import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "event-cluster-marker__selected-circle"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LIcon = _resolveComponent("LIcon")!
  const _component_LMarker = _resolveComponent("LMarker")!

  return (_openBlock(), _createBlock(_component_LMarker, {
    "lat-lng": _ctx.latLng,
    onClick: _ctx.handleClick
  }, {
    default: _withCtx(() => [
      _createVNode(_component_LIcon, {
        iconSize: [_ctx.radius, _ctx.radius],
        "class-name": "event-cluster-marker__wrapper"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", {
            class: "event-cluster-marker",
            style: _normalizeStyle(_ctx.computedStyle)
          }, [
            (_ctx.selected)
              ? (_openBlock(), _createElementBlock("div", _hoisted_1))
              : _createCommentVNode("", true),
            _createElementVNode("div", {
              class: _normalizeClass(['event-cluster-marker__label label-mono-s', { 'event-cluster-marker__label_selected': _ctx.selected }])
            }, _toDisplayString(_ctx.label), 3)
          ], 4)
        ]),
        _: 1
      }, 8, ["iconSize"])
    ]),
    _: 1
  }, 8, ["lat-lng", "onClick"]))
}